module.exports = __webpack_public_path__ + "img/6-evidence-group.4c4de6a6.png";